import { render, staticRenderFns } from "./MiniGame.vue?vue&type=template&id=732872a6&scoped=true"
import script from "./MiniGame.vue?vue&type=script&lang=js"
export * from "./MiniGame.vue?vue&type=script&lang=js"
import style0 from "./MiniGame.vue?vue&type=style&index=0&id=732872a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732872a6",
  null
  
)

export default component.exports